import * as React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocalization } from "../hooks/use-localization"

const Seo = ({ location, pageContext }) => {
  const { locale, config, defaultLang, prefixDefault } = useLocalization()
  const data = useStaticQuery(graphql`
    query LocalizationSEOQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  const defaultSiteUrl = data.site.siteMetadata.siteUrl

  // Use originalPath (set by this plugin in onCreatePage) as the page identifier,
  // independent of locale prefix. Normalize to end with "/" so URLs match the
  // served paths and sitemap (Gatsby v5 default trailingSlash = "always").
  const originalPath = pageContext.originalPath || `/`
  const normalizedPath = originalPath.endsWith(`/`)
    ? originalPath
    : `${originalPath}/`

  const buildLangUrl = (langCode) => {
    if (langCode === defaultLang && !prefixDefault) {
      return `${defaultSiteUrl}${normalizedPath}`
    }
    return `${defaultSiteUrl}/${langCode}${normalizedPath}`
  }

  const currentUrl = buildLangUrl(locale)
  const defaultLangUrl = buildLangUrl(defaultLang)

  return (
    <Helmet>
      <html lang={pageContext.hrefLang} />
      <link rel="canonical" href={currentUrl} />
      <link rel="alternate" hrefLang="x-default" href={defaultLangUrl} />
      <link rel="alternate" hrefLang={pageContext.hrefLang} href={currentUrl} />
      {config.map((l) => {
        if (l.code === locale) return null
        return (
          <link
            key={l.code}
            rel="alternate"
            hrefLang={l.hrefLang}
            href={buildLangUrl(l.code)}
          />
        )
      })}
      <meta
        property="og:locale"
        content={pageContext.hrefLang.replace(`-`, `_`)}
      />
      {config.map((l) => {
        if (l.code === locale) return null
        return (
          <meta
            key={l.code}
            property="og:locale:alternate"
            content={l.hrefLang.replace(`-`, `_`)}
          />
        )
      })}
    </Helmet>
  )
}

export { Seo }